module.exports = __webpack_public_path__ + "static/media/edit.e9f0d501.svg";